// The ONE module in this app that reads `process.env`.
//
// Nothing else may touch the bundler's env object: a component that reads
// `process.env.REACT_APP_…` directly is invisible to a grep for "what does this
// build actually need", cannot be stubbed in a test, and ties app code to
// Create React App. Everything imports the named values below instead.
//
// Only three kinds of value legitimately arrive as a build-time variable:
//
//   1. the environment SELECTOR — which entry of ./environments.json to use;
//   2. SECRETS, which must never sit in a checked-in manifest;
//   3. the BUILD STAMP injected by CI (version + commit).
//
// Per-environment NON-SECRET config (backend and ABDM origins, the public
// origin, RUM ids) does not belong here at all — it lives in
// ./environments.json. The per-value overrides below are the one concession:
// the compose stack points the app at container hostnames that no checked-in
// manifest can express.
//
// Each read is written out in full (`process.env.REACT_APP_X`) because that is
// the form CRA statically replaces at build time; aliasing or computing the key
// would leave the variable unresolved in the bundle. CRA only replaces names
// prefixed `REACT_APP_` — an unprefixed one silently becomes `undefined`, which
// is exactly how the ABHA client shipped with no base URL in prod and stage
// until 2026-09-01.
//
// `process.env.NODE_ENV` is deliberately absent: it is set by the CRA toolchain
// itself, not by our configuration, and is only read by framework boilerplate
// (./serviceWorkerRegistration.js, vendored from the CRA template).

/** Selects an entry of ./environments.json. Unset outside CI — see ./environment.js. */
export const ENV_NAME = process.env.REACT_APP_ENV;

/** Google Maps browser key for the clinic map. Optional locally — the map degrades. */
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

/** Build stamp baked by the deploy workflows; both absent in local dev. */
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const GIT_SHA = process.env.REACT_APP_GIT_SHA;

/**
 * Per-value escape hatches over the manifest entry, keyed by manifest field.
 * Only defined, non-empty values win (see ./index.js).
 */
export const OVERRIDES = {
  backendUrl: process.env.REACT_APP_BACKEND_API,
  abdmUrl: process.env.REACT_APP_ABDM_BACKEND_URL,
  publicUrl: process.env.REACT_APP_PUBLIC_URL,
};
